// extracted by mini-css-extract-plugin
module.exports = {"resend":"style_resend__21AsL"};